import React, {useEffect} from 'react';
import {Modal} from "react-bootstrap";
import {closeDeleteModal, deleteInstallation} from "../redux-store/installations";
import {useDispatch, useSelector} from "react-redux";
import {
    deleteItemConfirmation,
    idMOdalForDelete,
} from "../redux-store/selectors";

const ConfirmationDialog = () => {
    const modalDeleteStatus = useSelector(deleteItemConfirmation)
    const idModalDelete = useSelector(idMOdalForDelete)
    const dispatch = useDispatch();

    const handleCloseModal = () => {
        dispatch(closeDeleteModal())
    }

    const handleDeleteItem = () => {
        dispatch(deleteInstallation(idModalDelete))
        dispatch(closeDeleteModal())
    }

    return (
        <Modal
            show={modalDeleteStatus}
            onHide={handleCloseModal}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton className={"modal-header-component text-center"}>
                <Modal.Title className={"title-confirm"}>Potvrda brisanja</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={"mb-5 text-left"}>
                    <h5>Da li ste sigurni da želite obrisati ovu instalaciju?</h5>
                </div>
                <div className={"modal-footer-component text-right"}>
                    <button className={"btn btn-modal-cancel"} onClick={handleCloseModal}>
                        Odustani
                    </button>
                    <button className={"btn btn-modal-confirm-delete"} onClick={handleDeleteItem}>Obriši</button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ConfirmationDialog;
